import { Box, Container, Heading, Text, Button, VStack } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

function Home() {
  return (
    <Box>
      <Container maxW="800px" py={12}>
        <VStack spacing={8} align="stretch">
          <Heading as="h1" size="2xl" textAlign="center" color="teal.800">
            Welcome to Mock Me, Please!
          </Heading>
          
          <Text fontSize="lg" lineHeight="tall">
            Auditioning is one of the worst parts of the music business. But one of the best ways to prepare for the big day is to, well, pretend it's the big day! The more simulations of your audition that you can do, the better prepared you'll be.
          </Text>
          
          <Text fontSize="lg" lineHeight="tall">
            That's where Mock Me, Please comes in. Founded by a professional orchestral cellist who's taken over a dozen auditions, Mock Me, Please connects you with great mentors to help you along your journey.
          </Text>
          
          <Text fontSize="lg" lineHeight="tall">
            Designed to be affordable and easy to use, Mock Me, Please allows you to schedule virtual mock auditions with mentors of your choice. They'll listen to your audition repertoire and provide thoughtful commentary. Plus, you'll get a recording of your session for your reference.
          </Text>
          
          <Text fontSize="lg" lineHeight="tall" fontWeight="bold">
            Don't go it alone. Play a mock for us!
          </Text>
          
          <Button
            as={RouterLink}
            to="/find-teacher"
            colorScheme="teal"
            size="lg"
            alignSelf="center"
            mt={4}
          >
            Find Your Teacher
          </Button>
        </VStack>
      </Container>
    </Box>
  );
}

export default Home; 